import { render } from "./DbFavoriteListDialog.vue?vue&type=template&id=51f6add6"
import script from "./DbFavoriteListDialog.vue?vue&type=script&lang=js"
export * from "./DbFavoriteListDialog.vue?vue&type=script&lang=js"

import "./DbFavoriteListDialog.vue?vue&type=style&index=0&id=51f6add6&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__